// extracted by mini-css-extract-plugin
module.exports = {"todo":"Todo_todo__1FLU_","list-count":"Todo_list-count__1gtNn"};